import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Button,
  OutlinedInput,
  InputAdornment,
  TextField
  // eslint-disable-next-line import/no-extraneous-dependencies
} from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Typeahead } from 'react-bootstrap-typeahead';
import { useTranslation } from 'react-i18next';
import SensorType from '../../../Model/sensorType';
import constants from '../../../constants';

interface Props {
  sensorType: SensorType | undefined;
  selectedSensorType: string;
  validateKaiterraSensorId: Function;
  onChangeValue: Function;
  ownerAccount: string | undefined;
  infrastructureAccount: string | undefined;
  sensorId: string | undefined;
  accounts: any[] | undefined;
  infrastructureMail: string | undefined;
  sensorsTypes: any[];
  typeSelected: Function;
  setOwnerMail: Function;
  setInfrastructurePercentage: Function;
  setInfrastructureAccount: Function;
  setOwnerAccount: Function;
  infrastructurePercentage: number | undefined;
  defaultInfrastructurePercentage: number;
  handleSubmit: Function;
  onCalibrationParams: Function;
  ownerMail: string | undefined;
  setInfrastructureMail: Function;
}

const AddSensorForm = ({
  sensorType,
  selectedSensorType,
  validateKaiterraSensorId,
  onChangeValue,
  ownerAccount,
  infrastructureAccount,
  sensorId,
  accounts,
  infrastructureMail,
  sensorsTypes,
  typeSelected,
  setOwnerMail,
  setInfrastructurePercentage,
  setInfrastructureAccount,
  setOwnerAccount,
  infrastructurePercentage,
  defaultInfrastructurePercentage,
  handleSubmit,
  onCalibrationParams,
  ownerMail,
  setInfrastructureMail
}: Props) => {
  const { t } = useTranslation();
  return (
    <Card sx={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
      <CardHeader
        sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)' }}
        subheader={t('ADD_SENSOR')}
      ></CardHeader>
      <CardContent>
        <Box noValidate component="form" autoComplete="off">
          <InputLabel className='inputLabel'>{t('TYPE')}</InputLabel>
          <FormControl fullWidth>
            <Select
              id="sensorType"
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 }
              }}
              size="small"
              defaultValue={
                sensorType?.key ? sensorType.key : selectedSensorType
              }
              onChange={(e: SelectChangeEvent) => {
                const value: any = e.target.value;
                const { code, friendlyName } = value as {
                  code: string;
                  friendlyName: string;
                };
                typeSelected(code, friendlyName);
              }}
            >
              {sensorsTypes &&
                sensorsTypes.map((item: any) => {
                  return (
                    <MenuItem key={item.code} value={item}>
                      {item.friendlyName}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
          <InputLabel className='inputLabel'>{t('SENSOR_ID')}</InputLabel>
          <FormControl fullWidth variant="outlined">
            <OutlinedInput
              id="sensorId"
              fullWidth
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 }
              }}
              size="small"
              type="text"
              value={sensorId}
              onChange={(e) => onChangeValue(e)}
              endAdornment={
                <>
               {sensorType?.value === 'KA' && <InputAdornment position="end">
                  <Button
                    variant="text"
                    id="button-addon2"
                    onClick={() => validateKaiterraSensorId()}
                  >
                    Valida
                  </Button>
                </InputAdornment> }
                </>
              }
            />
          </FormControl>
          {sensorType?.value === 'AQ' && (
            <>
              <InputLabel className='inputLabel'> {t('ICCID')}</InputLabel>
              <TextField
                id="iccid"
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                fullWidth
                size="small"
                type="text"
                onChange={(e) => onChangeValue(e)}
              />
            </>
          )}
          <InputLabel className='inputLabel'>{t('ACCOUNT_OWNER')}</InputLabel>
          <Typeahead
            clearButton
            defaultInputValue={ownerAccount}
            id="algoAccount"
            labelKey={'account'}
            key={'algoAccount'}
            filterBy={(option, props) => {
              const label = `${option.mail} - ${option.account}`.toLowerCase();
              const searchTerm = props.text.toLowerCase();
              return label.indexOf(searchTerm) > -1;
            }}
            onChange={(account) => {
              setOwnerMail(account[0] ? account[0]?.mail : '');
              setOwnerAccount(account[0] ? account[0].account : '');
            }}
            onBlur={(e: any) => {
              setOwnerAccount(e.target?.value);
            }}
            options={accounts || []}
            renderMenuItemChildren={(option) =>
              `${option.mail} - ${option.account}`
            }
          />

          <InputLabel className='inputLabel'>{t('MAIL_OWNER')}</InputLabel>
          <TextField
            id="ownerMail"
            fullWidth
            required
            type="mail"
            sx={{
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 }
            }}
            size="small"
            value={ownerMail}
            onChange={(e) => onChangeValue(e)}
          />
          <InputLabel className='inputLabel'>{t('ACCOUNT_INFRASTRUCTURE')}</InputLabel>
          <Typeahead
            clearButton
            defaultInputValue={infrastructureAccount}
            id="algoInfraAccount"
            labelKey={'account'}
            key={'algoInfraAccount'}
            filterBy={(option, props) => {
              const label = `${option.mail} - ${option.account}`.toLowerCase();
              const searchTerm = props.text.toLowerCase();
              return label.indexOf(searchTerm) > -1;
            }}
            onChange={(account) => {
              setInfrastructurePercentage(
                constants.add_sensors.infrastructure_percentage
              );
              setInfrastructureMail(account[0] ? account[0].mail : '');
              setInfrastructureAccount(account[0] ? account[0].account : '');
            }}
            onBlur={(e: any) => {
              setInfrastructureAccount(e.target?.value);
            }}
            options={accounts || []}
            renderMenuItemChildren={(option) =>
              `${option.mail} - ${option.account}`
            }
          />
          {infrastructureAccount && (
            <>
              <InputLabel className='inputLabel'>{t('INFRASTRUCTURE_PERCENTAGE')}</InputLabel>
              <TextField
                fullWidth
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 }
                }}
                size="small"
                id="infrastructurePercentage"
                required={true}
                defaultValue={
                  infrastructurePercentage || defaultInfrastructurePercentage
                }
                inputProps={{ pattern: '(?:99(?:[.,]00?)?|d?d(?:[.,]dd?)?)$' }}
                title={t('INFRASTRUCTURE_PERCENTAGE_VALIDATOR')}
                onChange={(e) => onChangeValue(e)}
              />
              <small>{t('INFRASTRUCTURE_PERCENTAGE_VALIDATOR')}</small>
            </>
          )}
          <InputLabel className='inputLabel'>{t('MAIL_INFRASTRUCTURE')}</InputLabel>
          <TextField
            id="infrastructureMail"
            fullWidth
            size="small"
            sx={{
              '& legend': { display: 'none' },
              '& fieldset': { top: 0 }
            }}
            type="email"
            required={!!infrastructureAccount}
            value={infrastructureMail}
            onChange={(e) => onChangeValue(e)}
          />
          {onCalibrationParams()}
        </Box>
      </CardContent>
      <CardActions>
        <Button
         style={{ marginLeft: 10, marginBottom: 10 }}
          variant="contained"
          type="submit"
          onClick={() => handleSubmit()}
        >
          {t('ADD')}
        </Button>
      </CardActions>
    </Card>
  );
};

export default AddSensorForm;
